/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable react/forbid-prop-types */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Ad from 'models/business/Ad';
import classNames from 'classnames';
import useValidateMedia from 'components/hooks/useValidateMedia';
import { Categories as PlatformCategories } from 'models/business/Platform';
import CarouselPlaceholderImage from 'assets/carousel-placeholder.png';
import Styles from './index.module.css';

export default function PhonePreview({
  className,
  ad,
  media,
  ...props
}) {
  // eslint-disable-next-line no-unused-vars
  const { validateImageName, validateVideoName } = useValidateMedia();
  const [imageSource, setImageSource] = useState('');
  const [videoSource, setVideoSource] = useState('');

  const loadLocalFile = async (file) => {
    const fileReader = new FileReader();
    await new Promise((resolve) => {
      fileReader.onload = resolve;
      fileReader.onerror = resolve;
      fileReader.readAsDataURL(file);
    });

    return fileReader.result || '';
  };

  useEffect(() => {
    if (ad.platform === PlatformCategories.FacebookCarousel) {
      setImageSource(CarouselPlaceholderImage);
      setVideoSource('');
      return;
    }

    if (media.local) {
      if (validateImageName(media.local.name || '')) {
        loadLocalFile(media.local).then((source) => {
          setImageSource(source);
          setVideoSource('');
        });
      } else if (validateVideoName(media.local.name || '')) {
        loadLocalFile(media.local).then((source) => {
          setVideoSource(source);
          setImageSource('');
        });
      } else {
        setImageSource('');
        setVideoSource('');
      }
    } else if (media.prepopulated) {
      if (validateImageName(media.prepopulated.name || '')) {
        setImageSource(media.prepopulated.url);
        setVideoSource('');
      } else if (validateVideoName(media.prepopulated.name || '')) {
        setVideoSource(media.prepopulated.url);
        setImageSource('');
      } else {
        setImageSource('');
        setVideoSource('');
      }
    } else {
      setImageSource('');
      setVideoSource('');
    }
  }, [media, ad.platform]);

  return (
    <div className={classNames(Styles.mainContainer, className)} {...props}>
      <div className={Styles.upperContainer}>
        <div className={Styles.microphone} />
        <div className={Styles.speakerContainer}>
          <div className={Styles.camera} />
          <div className={Styles.speaker} />
        </div>
      </div>
      <div className={Styles.contentContainer}>
        <div className={Styles.contentTopBar} />
        <div className={Styles.contentHeaderBar}>
          <div className={Styles.contentHeaderSquare} />
          <div className={Styles.contentHeaderText}>
            <div className={Styles.contentHeaderTitle}>
              您的賣場粉絲團名稱
            </div>
            <div className={Styles.contentHeaderSubtitle}>
              贊助
            </div>
          </div>
        </div>
        <div className={Styles.contentSubHeaderTitle}>{ad.mainCopy}</div>
        <div className={Styles.contentImageContainer}>
          {imageSource && <img className={Styles.contentImage} alt="" src={imageSource} />}
          {/* {videoSource && (
            <video className={Styles.contentVideo} autoPlay loop>
              <source src={videoSource} />
              {media.local?.name || media.prepopulated?.name || '影片'}
            </video>
          )} */}
          {videoSource && (
            <div className={Styles.contentVideoName}>{media.local?.name || media.prepopulated?.name || '影片'}</div>
          )}
        </div>
        {ad.platform === PlatformCategories.FacebookCarousel && (
          <>
            <div className={Styles.contentCtaContainer}>
              <div className={Styles.ctaPrice}>
                <div>商品名稱</div>
                <div>NT$399</div>
              </div>
              <div className={Styles.cta}>
                {ad.cta}
              </div>
            </div>
            <div className={Styles.contentFacebookBar} />
          </>
        )}
        {ad.platform === PlatformCategories.FacebookFeatured && (
          <>
            <div className={Styles.contentDescription}>
              {ad.title}
            </div>
            <div className={Styles.contentButtons}>
              <div className={Styles.contentButton}>
                賣場
                <br />
                產品圖
              </div>
              <div className={Styles.contentButton}>
                賣場
                <br />
                產品圖
              </div>
              <div className={Styles.contentButton}>更多</div>
            </div>
          </>
        )}
      </div>
      <div className={Styles.lowerContainer} />
    </div>
  );
}

PhonePreview.propTypes = {
  className: PropTypes.string,
  ad: PropTypes.instanceOf(Ad),
  media: PropTypes.object,
};

PhonePreview.defaultProps = {
  className: '',
  ad: new Ad(),
  media: { local: null, prepopulated: null },
};
